import UserGroupFormLayout, { transformValues } from './form'
import GenericEditForm from '../common/edit'

export default () => <GenericEditForm formLayoutComponent={<UserGroupFormLayout />} transformValues={transformValues} />
